import { render, staticRenderFns } from "./send-success.vue?vue&type=template&id=fa01981a&"
import script from "./send-success.vue?vue&type=script&lang=js&"
export * from "./send-success.vue?vue&type=script&lang=js&"
import style0 from "./send-success.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports